
import './App.css';
import './css/header.css';
import './css/banner.css';
import './css/bannercards.css';
import Home from './home';
function App() {
  return (
    <div className="App">
        <Home />
    </div>
  );
}

export default App;
